<template>
  <div
    v-if="showContextMenu"
    class="context-menu"
    :class="{ 'hidden-overlay': !overlay }"
  >
    <div
      ref="contentRef"
      class="content"
      :class="{ 'hidden-overlay': !overlay }"
      :style="styles"
      v-click-outside="handleCloseModal"
    >
      <slot v-bind="{ items }"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 220,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showContextMenu: false,
      items: {},
      styles: {},
    };
  },
  methods: {
    init(event, request) {
      const screen = { width: window.innerWidth, height: window.innerHeight };

      let x = event.clientX - this.width;

      if (event.clientX < this.width + 15) {
        x = event.clientX;

        if (x + this.width + 15 > screen.width) {
          x = screen.width - this.width - 10;
        }
      } else {
        if (event.clientX + this.width + 15 <= screen.width) {
          x = x + this.width + 5;
        }
      }

      this.showContextMenu = true;
      this.items = request;

      this.$nextTick(() => {
        let y = event.clientY - this.$refs.contentRef.offsetHeight;

        if (event.clientY < this.$refs.contentRef.offsetHeight + 15) {
          y = event.clientY;

          if (y + this.$refs.contentRef.offsetHeight + 15 > screen.height) {
            y = screen.height - this.$refs.contentRef.offsetHeight - 20;
          }
        } else {
          if (
            event.clientY + this.$refs.contentRef.offsetHeight + 15 <=
            screen.height
          ) {
            y = y + this.$refs.contentRef.offsetHeight + 5;
          }
        }

        this.styles = {
          width: this.width + "px",
          top: y + "px",
          left: x + "px",
        };
      });
    },

    handleCloseModal() {
      this.showContextMenu = false;

      this.styles = { width: this.width + "px" };
    },
  },
};
</script>

<style lang="scss" scoped>
.context-menu {
  position: fixed;
  background-color: rgba(24, 24, 24, 0.2);
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1000;

  &.hidden-overlay {
    background-color: transparent;
  }

  .content {
    background-color: #fff;
    border-radius: 4px;
    position: absolute;
    z-index: 1;
  }
}
</style>
